/**
 * iurop-faq.js — FAQs con categorías filtrables (Atisse)
 *
 * Las pestañas (data-faq-tab) filtran los <details> por data-faq-category.
 * Pestaña vacía = "All" (muestra todo). Re-init en shopify:section:load.
 */
(function () {
  'use strict';

  var NL_FLAG = 'iurop:faq-nl-posted';

  function setupNewsletterModal(root) {
    var modal = root.querySelector('[data-faq-nl-modal]');
    if (!modal) return;

    function open() {
      modal.hidden = false;
      document.documentElement.classList.add('iurop-faq-modal-open');
      var input = modal.querySelector('.iurop-faq__nl-input');
      if (input) input.focus();
    }

    function close() {
      modal.hidden = true;
      document.documentElement.classList.remove('iurop-faq-modal-open');
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-faq-nl-open]')) { open(); return; }
      if (e.target.closest('[data-faq-nl-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    // El form 'customer' recarga la página al enviar: se marca el envío y,
    // a la vuelta, si hay resultado (éxito o error) se reabre el modal para
    // enseñarlo (el flag evita confundirlo con el newsletter del footer).
    var form = modal.querySelector('[data-faq-nl-form]');
    if (form) {
      form.addEventListener('submit', function () {
        try { window.sessionStorage.setItem(NL_FLAG, '1'); } catch (_) {}
      });
    }
    var posted = false;
    try { posted = window.sessionStorage.getItem(NL_FLAG) === '1'; } catch (_) {}
    if (posted) {
      try { window.sessionStorage.removeItem(NL_FLAG); } catch (_) {}
      if (modal.querySelector('[data-faq-nl-result]')) open();
    }
  }

  function init(root) {
    if (root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    setupNewsletterModal(root);

    var list = root.querySelector('.iurop-faq__list');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-faq-tab]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-category]'));
    if (!list || !items.length) return;

    // Dos columnas INDEPENDIENTES: abrir una pregunta solo afecta a su columna
    // (con el grid de filas, abrir una estiraba la fila y dejaba hueco en la otra).
    var col1 = document.createElement('div');
    var col2 = document.createElement('div');
    col1.className = 'iurop-faq__col';
    col2.className = 'iurop-faq__col';
    list.innerHTML = ''; // los items siguen referenciados en `items`
    list.appendChild(col1);
    list.appendChild(col2);
    list.classList.add('iurop-faq__list--cols');

    // Reparte los items VISIBLES alternando entre las 2 columnas (las equilibra
    // al filtrar). Los ocultos se aparcan en col1 ([hidden] = no ocupan espacio).
    function distribute() {
      var visible = items.filter(function (it) { return !it.hidden; });
      col1.textContent = '';
      col2.textContent = '';
      visible.forEach(function (it, i) {
        (i % 2 === 0 ? col1 : col2).appendChild(it);
      });
      items.forEach(function (it) { if (it.hidden) col1.appendChild(it); });
    }
    distribute();

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var cat = tab.dataset.faqTab;
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        items.forEach(function (item) {
          var show = cat === '' || item.dataset.faqCategory === cat;
          item.hidden = !show;
          if (!show) item.open = false;
        });
        distribute();
      });
    });

    // Al entrar, activa la primera categoría (no "Todas").
    var firstCat = tabs.filter(function (t) { return t.dataset.faqTab !== ''; })[0];
    if (firstCat) firstCat.click();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-iurop-faq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) {
      e.target.querySelectorAll('[data-iurop-faq]').forEach(function (el) {
        el.dataset.faqInit = '';
      });
      initAll(e.target);
    }
  });
})();
